export enum ChemistryMoleculeVersionActionType {
  CHEMISTRY_UPDATE_MOLECULE_VERSION = 'CHEMISTRY_UPDATE_MOLECULE_VERSION',
}

interface ChemistryUpdateMoleculeVersionAction {
  type: ChemistryMoleculeVersionActionType.CHEMISTRY_UPDATE_MOLECULE_VERSION;
  moleculeId: string;
  moleculeVersionId: string;
}

export function updateMoleculeVersion(
  moleculeId: string,
  moleculeVersionId: string
): ChemistryUpdateMoleculeVersionAction {
  return {
    type: ChemistryMoleculeVersionActionType.CHEMISTRY_UPDATE_MOLECULE_VERSION,
    moleculeId,
    moleculeVersionId,
  };
}

export type ChemistryMoleculeVersionAction = ChemistryUpdateMoleculeVersionAction;
